<template>
  <path
    d="M5.35714 60.0625C6.96429 60.0625 8.3801 59.5494 10.1403 58.6258L55.3316 35.262C58.6224 33.5517 60 32.2176 60 30.0625C60 27.9074 58.6224 26.6075 55.3316 24.863L10.1403 1.49922C8.3801 0.575613 6.96429 0.0625 5.35714 0.0625C2.21939 0.0625 0 2.21757 0 5.60412V54.5209C0 57.9416 2.21939 60.0625 5.35714 60.0625Z"
  />
</template>
